import { render } from "./SmileyIcon.vue?vue&type=template&id=621d15d0"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SmileyIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "621d15d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('621d15d0', __exports__)) {
    api.reload('621d15d0', __exports__)
  }
  
  module.hot.accept("./SmileyIcon.vue?vue&type=template&id=621d15d0", () => {
    api.rerender('621d15d0', render)
  })

}


export default __exports__